<template>
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <slot></slot>
        </div>
        <button class="swiper-navigation-button swiper-button-prev">
            <swiper-next/>
        </button>
        <div class="swiper-pagination" v-if="paginate"></div>
        <button class="swiper-navigation-button swiper-button-next">
            <swiper-next/>
        </button>
    </div>
</template>

<script>
import Swiper from 'swiper';
import eventBus from 'src/util/eventBus';
import SwiperNext from 'src/components/icons/SwiperNext';

export default {
    props: {
        paginate: {
            type: Boolean,
            default: false,
        },
        centeredSlides: {
            type: Boolean,
            default: true,
        },
        spaceBetween: {
            type: Number,
            default: null,
        },
        swiperConfig: {
            type: Object,
            default: () => ({}),
        },
    },
    components: {
        SwiperNext,
    },
    mounted() {
        this.initSwiper();
        this.listenForHomeSort();
    },
    destroyed() {
        eventBus.$off('sort');
    },
    watch: {
        swiperConfig() {
            if (this.swiper) {
                this.swiper.destroy();

                this.initSwiper();
            }
        },
    },
    methods: {
        initSwiper() {
            this.swiper = new Swiper(this.$el, {
                centeredSlides: this.centeredSlides,
                spaceBetween: this.spaceBetween,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: this.$el.querySelector('.swiper-button-next'),
                    prevEl: this.$el.querySelector('.swiper-button-prev'),
                },
                ...this.swiperConfig,
            });
        },
        listenForHomeSort() {
            if (this.$route.name !== 'historical') {
                return;
            }

            eventBus.$on('sort', ({ newKey }) => {
                const slideMapping = {
                    gross: 0,
                    gross_potential_percentage: 0,
                    diff_revenue_last_week: 0,
                    diff_attendance_last_week: 1,
                    attendance: 1,
                    capacity_percentage: 1,
                    ticket_average: 2,
                    ticket_min: 2,
                    ticket_max: 2,
                    ticket_top: 2,
                };

                if (typeof slideMapping[newKey] !== 'undefined') {
                    this.swiper.slideTo(slideMapping[newKey]);
                }
            });
        },
    },
};
</script>
